<template lang="pug">
  .settings
    v-container(style="max-width:600px")
      p.title.my-2 Affiliate Debug
      v-card
        v-card-text
          v-list
            v-list-item
              v-list-item-content
                v-list-item-title User was invited by:
                v-list-item-subtitle {{ member.user.agent_affiliate_id }}
            v-list-item
              v-list-item-content
                v-list-item-title Company was created by user who was invited by:
                v-list-item-subtitle {{ company.agent_affiliate_id }}
            v-list-item
              v-list-item-content
                v-list-item-title Recurring? (2nd month onwards)
              v-list-item-action
                y-switch()
            v-list-item
              v-list-item-content
                v-btn(block) Simulate payment (1-month Personal)
            v-list-item
              v-list-item-content
                v-btn(block) Simulate payment (1-month Business)
            v-list-item
              v-list-item-content
                v-btn(block) Simulate payment (1-month Intelligence)
            v-list-item
              v-list-item-content
                v-btn(block) Simulate payment (1-year Personal)
            v-list-item
              v-list-item-content
                v-btn(block) Simulate payment (1-year Business)
            v-list-item
              v-list-item-content
                v-btn(block) Simulate payment (1-year Intelligence)
</template>

<script>
  import { mapState, mapGetters } from 'vuex'

export default {
  name: "AffiliateDebug",
  data: () => ({
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    })
  },
  methods: {
    send () {

  }
  }
}
</script>

<style lang="scss" scoped>

</style>